import type { IWebSourceFilterItem } from "@similarweb/ui-components";
import { WebSourceFilter } from "@similarweb/ui-components";

import { headerTracking } from "app/pages/digital-marketing/monitor-and-protect/services/tracking/header";
import { useCurrentCampaignLocations } from "app/pages/digital-marketing/monitor-and-protect/services/api/campaign";
import { useTranslation } from "pro-features/components/WithTranslation";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { useMonitorAndProtectDataAndParams } from "../../../hooks/navigations";
import type { IFilter } from "../FiltersBar";

const DeviceFilterItem = () => {
    const translate = useTranslation();
    const { device } = useMonitorAndProtectDataAndParams();
    const locations = useCurrentCampaignLocations();

    const DEVICE_ITEMS = [
        {
            id: "All",
            text: translate("websources.all.devices"),
            icon: "combined",
        },
        {
            id: "Desktop",
            text: translate("websources.desktop"),
            icon: "desktop",
        },
        {
            id: "MobileWeb",
            text: translate("websources.mobileweb"),
            icon: "mobile-web",
        },
    ];

    const handleDeviceChange = (item: IWebSourceFilterItem) => {
        headerTracking.filterDeviceSelect(
            item.text,
            locations.map((e) => e.countryCode),
        );
        proNavigator.updateQueryParams(
            {
                device: item.id,
            },
            {
                reload: false,
            },
        );
    };

    return (
        <WebSourceFilter
            height="60px"
            selectedIds={{
                [device]: true,
            }}
            items={DEVICE_ITEMS}
            onChange={(item) => handleDeviceChange(item as unknown as IWebSourceFilterItem)}
        />
    );
};

export const deviceFilterConfigItem: IFilter = {
    id: "device",
    filter: <DeviceFilterItem />,
};
